import styled from "@emotion/styled";

export const SpacerBottom = styled.div<{ spacing: number }>`
  ${({ spacing, theme }) => `padding-bottom: ${theme.spacing(spacing)}`};
  width: 100%;
`;
